import { Button } from '@mui/material';
import React from 'react';
import { getPolyglot } from '../../../../../../i18n';
import { DeleteIcon } from '../../../../../../theme/icons';

interface DeleteGroupButtonProps {
  openDeleteGroup: () => void;
}
export const DeleteGroupButton = ({
  openDeleteGroup,
}: DeleteGroupButtonProps) => {
  const polyglot = getPolyglot();
  return (
    <Button
      variant="text"
      color="error"
      startIcon={<DeleteIcon />}
      onClick={openDeleteGroup}
    >
      {polyglot.t('group.tooltip.delete_group')}
    </Button>
  );
};
